import React, {useRef, useState} from 'react';
import ReactPlayer from 'react-player';
import {Grid} from '@mui/material';
import fondo from '../../Recursos/fondo_video.png';
import fondo_pause from '../../Recursos/fondo_video.png';
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";

export const VideoNoAdalantable = ({url, setTermino, termino}) => {
    const {sCell} = useResponsive()
    const [play, setPlay] = useState(false);
    const playerRef = useRef(null);


    const handleEnded = () => {
        setTermino(true);
        setPlay(false);
    };

    const empezar = () => {
        setTimeout(() => {
            setPlay(true);
        }, 1500)
    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 9}}
        >
            <Grid
                onClick={() => setPlay(!play)}
                container
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    justifyContent: 'flex-start',
                    cursor: 'pointer',
                    position: 'relative',
                    overflow: 'hidden',
                    borderRadius: 6,

                    backgroundImage: play ? `url(${fondo_pause})` : `url(${fondo})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',

                    '& .react-player, & video': {
                        transition: 'opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
                        opacity: 1,
                    },
                    ...(!play && {
                        '&:hover .react-player, &:hover video': {
                            opacity: 0.4,
                        },
                        '&:hover .contador-tiempo': {
                            opacity: 1,
                        },
                    }),

                    // Hacemos que el overlay del tiempo aparezca o se resalte en el hover
                    '&:hover .contador-tiempo': {
                        opacity: 1,
                    },
                }}
            >
                <ReactPlayer
                    className="react-player"
                    ref={playerRef}
                    src={url}
                    playing={play}
                    onReady={empezar}
                    controls={false}
                    width="100%"
                    height="100%"
                    onEnded={handleEnded}
                    config={{
                        file: {
                            attributes: {
                                onContextMenu: (e) => e.preventDefault(),
                                controlsList: 'nodownload nofullscreen',
                            },
                        },
                    }}
                />


            </Grid>
        </Grid>
    );
};